import Loader from "components/shared/loader";
import React from "react";
import { getBidScenarios } from "sources/books/tripScenarios";
import ScenarioAnswersModal from "./scenarioAnswersModal";

export default class TripScenarioAnswersModal extends ScenarioAnswersModal {
    state = {
        isLoading: true,
        data: null,
    };

    componentDidMount() {
        getBidScenarios(this.props.bid.id).then((data) => this.setState({ data, isLoading: false }));
    }

    renderBody = () => {
        if (this.state.isLoading) {
            return <Loader />;
        }
        if (this.state.data.length === 0) {
            return <h5 className="text-center">По данной заявке нет пройденных опросов</h5>;
        }
        return this.state.data.map(({ scenario }, i) => (
            <div key={i} className="answer__list-card mb-3">
                <div className="card-body">
                    <div>{scenario.name}</div>
                    <div className="text-muted pb-3">{scenario.description}</div>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Вопрос</th>
                                <th>Ответ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scenario.questions.map((question, i) => (
                                <tr key={question.id}>
                                    <td>{i + 1}</td>
                                    <td>{question.text}</td>
                                    <td>{this.renderAnswer(question, question.answer)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        ));
    };
}
